<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="ewb-footer-hd">
		<div class="containers clearfix">
			<div class="col-md-5 ewb-footer-info col-md-offset-1 " >
				<div class="ewb-work-time glyphicon glyphicon-earphone">联系我们</div>
				<ul class="ewb-work-list clearfix">
					<li>
						<h3>公司地址：中国 江苏省 昆山市 同丰东路1225号</h3>
					</li>
					<li>
						<h3>联系电话：0512-57597986</h3>
					</li>
					<li>
						<h3>电子传真：86-21-32501399</h3>
					</li>
				</ul>
			</div>
			<ul class="col-md-5 ewb-footer-list ">
        
				<li class="col-md-4 col-sm-4 col-xs-4" style="padding-right: 0;">
					<h3 class="ewb-footer-tt">
						<a>关于华胤</a>
					</h3>
					<ul>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="togyhy1">华胤简介</a>
						</li>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="togyhy2">华胤文化</a>
						</li>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="togyhy4">华胤新闻</a>
						</li>
            <li class="ewb-footer-name">
							<a href="javascript:;" @click="togyhy5">资质荣誉</a>
						</li>
					</ul>
				</li>
				<li class="col-md-4 col-sm-4 col-xs-4" style="padding-right: 0;">
					<h3 class="ewb-footer-tt">
						<a>产品与服务</a>
					</h3>
					<ul>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="tohyzz1">华胤制造</a>
						</li>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="tohyjz1">华胤建造</a>
						</li>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="tohycz1">华胤创造</a>
						</li>
            <li class="ewb-footer-name">
							<a href="javascript:;" @click="tohyxny">国盛新能源</a>
						</li>
					</ul>
				</li>
				<li class="col-md-4 col-sm-4 col-xs-4">
					<h3 class="ewb-footer-tt">
						<a>成功案例</a>
					</h3>
					<ul>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="tocgal1">行业案例</a>
						</li>
						<li class="ewb-footer-name">
							<a href="javascript:;" @click="tocgal2">典型分析</a>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
    <footer>
        <div class="container-fluid">
            <div class="container">
				<p>版权所有：华胤钢结构工程（江苏）有限公司&nbsp;备案序号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">苏ICP备2023025063号</a></p>
			</div>
        </div>
    </footer>
    
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import Loader from '../skip/Loader.vue';
export default {
  methods:{
    // 关于华胤
    togyhy1() {
      if (this.$route.fullPath != '/gyhy') {
        this.isLoading = true;
        this.$router.push('/gyhy').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    togyhy2() {
      if (this.$route.fullPath != '/gyhy#gswh') {
        this.isLoading = true;
        this.$router.push({
          path: '/gyhy',
          hash: '#gswh',
        }).then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    togyhy4() {
      if (this.$route.fullPath != '/gyhy#hyxw') {
        this.isLoading = true;
        this.$router.push({
          path: '/gyhy',
          hash: '#hyxw',
        }).then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    togyhy5() {
      if (this.$route.fullPath != '/gyhy#gsry') {
        this.isLoading = true;
        this.$router.push({
          path: '/gyhy',
          hash: '#gsry',
        }).then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    // 华胤制造
    tohyzz1() {
      if (this.$route.fullPath != '/hyzz') {
        this.isLoading = true;
        this.$router.push('/hyzz').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    // 华胤建造
    tohyjz1() {
      if (this.$route.fullPath != '/hyjz') {
        this.isLoading = true;
        this.$router.push('/hyjz').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    // 华胤创造
    tohycz1() {
      if (this.$route.fullPath != '/hycz') {
        this.isLoading = true;
        this.$router.push('/hycz').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    // 华胤新能源
    tohyxny(){
      if (this.$route.fullPath != '/hyxny') {
        this.isLoading = true;
        this.$router.push('/hyxny').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    // 成功案例
    tocgal1() {
      if (this.$route.fullPath != '/cgal') {
        this.isLoading = true;
        this.$router.push('/cgal').then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
    tocgal2() {
      if (this.$route.fullPath != '/cgal#alfx') {
        this.isLoading = true;
        this.$router.push({
          path: '/cgal',
          hash: '#alfx',
        }).then(() => {
          location.reload();
        }).finally(() => {
          window.addEventListener('load', () => {
            this.isLoading = false;
          });
        });
      }
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Loader,
  },
}
</script>

<style scoped>
body::-webkit-scrollbar {
  width: 0;
  height: 8px;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Add a thumb */
body::-webkit-scrollbar-thumb {
    background: rgba(250, 250, 250, 0.5);
}

body, html {
  height: 100%;
  min-height: 100%;
}
a {
  text-decoration: none;
}
a:hover{
  text-decoration: none;
}

ol,ul,li{
  margin: 0;
  padding: 0;
  list-style: none !important;
}
.col-xs-4, .col-sm-4, .col-md-4{
  padding: 0 15px;
}
footer {
  width: 100%;
  height: 80px;
  background-color: #313131;
}

footer p {
  text-align: center;
  color: #fff;
  font-weight: 200;
  font-size: 13px;
  text-transform: uppercase;
  padding-top: 33px;
  letter-spacing: 0.5px;
}

footer a {
  color: #aaa;
  text-decoration: none;
}

footer a:hover {
  text-decoration: none;
  color: #aaa;
}
.ewb-footer-hd {
  padding-bottom: 10px;
  min-height: 192px;
  background-color: #313131;
}
.containers {
  margin-right: auto;
  margin-left: auto;
  padding-top: 10px;
}
.ewb-footer-info {
  float: left;
  padding-top: 12px;
  padding-left: 20px;
  background: url('../img/footer_line.jpg')right center no-repeat;
}
.ewb-work-time {
  margin-top: 10px;
  padding-left: 28px;
  height: 56px;
  line-height: 56px !important;
  font-size: 28px;
  color: #fff;
}
.ewb-footer-list {
  float: left;
  margin: 16px 0 0 48px;
}

.ewb-work-list>li {
  
  padding-left: 10px;
  /* width: 194px; */
  width: auto;
  vertical-align: top;
}
.ewb-work-list>li>h3 {
  height: 26px;
  line-height: 26px;
  color: #fff;
  font-size: large;
  margin-top: 10px;
  font-family: 微软雅黑;
}

.ewb-footer-list {
  float: left;
  margin: 16px 0 0 48px;
}
.ewb-footer-tt {
  height: 48px;
  line-height: 48px;
  font-size: 20px;
}
.ewb-footer-tt>a, .ewb-footer-name>a {
  color: #fff;
}
.ewb-footer-name {
  height: 29px;
  line-height: 29px;
  vertical-align: top;
}
@media screen and (max-width:970px) {
  .ewb-work-list>li>h3 {
    font-size: 14px;
}
  .work-grids{
      height: auto !important;
  }
  .ewb-footer-info {  
      width: 100%;
      font-size: 17px;
      padding: 0 !important;
  }
  .ewb-footer-list {
      float: left !important;
      margin: 0 !important;
      width: 100%;
  }
  .container-fluid p{
    padding-top: 15px;
  }
  .ewb-footer-tt {
  font-size: 17px;
}
}
@media screen and (min-width: 2000px){
  .ewb-work-time{
    font-size: 40px;
  }
  .ewb-work-list>li>h3{
    height: 35px;
    line-height: 40px;
    font-size: 25px;
  }
  .ewb-footer-tt{
    font-size: 30px;
  }
  .ewb-footer-name{
    font-size: 20px;
  }
}

</style>